var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.9 11.314 8.485 8.485 1.414-1.414L11.314 9.9l8.485-8.486L18.385 0 9.9 8.485 1.414 0 0 1.414 8.485 9.9 0 18.385l1.414 1.414L9.9 11.314Z",
    fill: "currentColor"
  })));
};

export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljg5OTU4IDExLjMxMzhMMTguMzg0OCAxOS43OTlMMTkuNzk5IDE4LjM4NDhMMTEuMzEzOCA5Ljg5OTU4TDE5Ljc5OSAxLjQxNDM3TDE4LjM4NDggMC4wMDAxNTE3NTNMOS44OTk1OCA4LjQ4NTM2TDEuNDE0MjEgMEwwIDEuNDE0MjFMOC40ODUzNiA5Ljg5OTU4TDEuMDM3MTJlLTA1IDE4LjM4NDlMMS40MTQyMiAxOS43OTkxTDkuODk5NTggMTEuMzEzOFoiIGZpbGw9IiMxMzM1NjQiLz4KPC9zdmc+Cg==";